import { c as _c } from "react/compiler-runtime";
import type { CountdownData } from "@/hooks/useMintCountdownState";
import { formatCountdownVerbose } from "@/utils/timeFormatters";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import Link from "next/link";
import { memo, useEffect, useRef, useState } from "react";
interface NowMintingCountdownActiveProps {
  readonly countdown: CountdownData;
}
export default function NowMintingCountdownActive(t0) {
  const $ = _c(16);
  const {
    countdown
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="tw-via-white/12 tw-pointer-events-none tw-absolute tw-inset-x-6 tw-top-0 tw-h-px tw-bg-gradient-to-r tw-from-white/0 tw-to-white/0" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== countdown.title) {
    t2 = <span className="tw-text-sm tw-font-semibold tw-text-iron-300">{countdown.title}</span>;
    $[1] = countdown.title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== countdown.isActive) {
    t3 = countdown.isActive && <div className="tw-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-border-success/20 tw-bg-success/10 tw-px-2.5 tw-py-1"><span className="tw-relative tw-flex tw-h-2 tw-w-2"><span className="tw-absolute tw-inline-flex tw-h-full tw-w-full tw-animate-ping tw-rounded-full tw-bg-success/60" /><span className="tw-relative tw-inline-flex tw-h-2 tw-w-2 tw-rounded-full tw-bg-success" /></span><span className="tw-text-[11px] tw-font-semibold tw-text-success/80">Live</span></div>;
    $[3] = countdown.isActive;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className="tw-mb-3 tw-flex tw-items-center tw-justify-between">{t2}{t3}</div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== countdown.targetDate) {
    t5 = <div className="tw-mb-4 tw-flex tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-white/5 tw-bg-iron-950 tw-p-4 tw-shadow-[inset_0_2px_4px_rgba(0,0,0,0.5)]"><div className="tw-text-2xl tw-font-bold tw-tabular-nums tw-text-iron-50"><LiveCountdown targetTimestampSeconds={countdown.targetDate} /></div></div>;
    $[8] = countdown.targetDate;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== countdown.showMintBtn) {
    t6 = countdown.showMintBtn ? <Link href="/the-memes/mint" className="tw-flex tw-h-12 tw-w-full tw-items-center tw-justify-center tw-gap-x-1.5 tw-whitespace-nowrap tw-rounded-lg tw-border-0 tw-bg-iron-200 tw-px-3.5 tw-py-2.5 tw-text-base tw-font-semibold tw-text-iron-950 tw-no-underline tw-ring-1 tw-ring-inset tw-ring-white tw-transition tw-duration-300 tw-ease-out focus:tw-z-10 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset desktop-hover:hover:tw-bg-iron-300 desktop-hover:hover:tw-text-iron-950 desktop-hover:hover:tw-ring-iron-300">Mint<ArrowRightIcon className="tw-size-4 tw-flex-shrink-0" strokeWidth={2} /></Link> : <div className="tw-h-12" />;
    $[10] = countdown.showMintBtn;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t5 || $[14] !== t6) {
    t7 = <div className="tw-relative tw-overflow-hidden tw-rounded-xl tw-border tw-border-solid tw-border-white/5 tw-bg-iron-800/40 tw-p-4 tw-text-left md:tw-p-5">{t1}{t4}{t5}{t6}</div>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}
const LiveCountdown = memo(t0 => {
  const $ = _c(7);
  const {
    targetTimestampSeconds
  } = t0;
  let t1;
  if ($[0] !== targetTimestampSeconds) {
    t1 = () => formatCountdownVerbose(targetTimestampSeconds);
    $[0] = targetTimestampSeconds;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [display, setDisplay] = useState(t1);
  const timerRef = useRef(null);
  let t2;
  let t3;
  if ($[2] !== targetTimestampSeconds) {
    t2 = () => {
      const targetMs = targetTimestampSeconds * 1000;
      const tick = () => {
        setDisplay(formatCountdownVerbose(targetTimestampSeconds));
        if (Date.now() >= targetMs) {
          return;
        }
        const now = Date.now();
        const msUntilNextSecond = 1000 - now % 1000;
        timerRef.current = setTimeout(tick, msUntilNextSecond);
      };
      tick();
      return () => {
        if (timerRef.current) {
          clearTimeout(timerRef.current);
        }
        timerRef.current = null;
      };
    };
    t3 = [targetTimestampSeconds];
    $[2] = targetTimestampSeconds;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== display) {
    t4 = <span>{display}</span>;
    $[5] = display;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
});
LiveCountdown.displayName = "LiveCountdown";